// @ts-nocheck
import React from 'react';
import type { AdminStats as AdminStatsType } from '../../types/admin';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, trend }) => {
  return (
    <div className="bg-white dark:bg-luna-primary rounded-xl border-2 border-luna-secondary/30 p-4 sm:p-6">
      <div className="flex items-center justify-between mb-3 sm:mb-4">
        <span className="material-symbols-outlined text-2xl sm:text-3xl text-luna-secondary">
          {icon}
        </span>
        {trend && (
          <span
            className={`text-xs sm:text-sm font-medium ${
              trend.isPositive ? 'text-green-600' : 'text-red-600'
            }`}
          >
            {trend.isPositive ? '+' : ''}
            {trend.value}%
          </span>
        )}
      </div>
      <h3 className="text-xl sm:text-2xl font-black text-luna-text-light dark:text-luna-text-dark mb-1">
        {value}
      </h3>
      <p className="text-xs sm:text-sm text-luna-text-light/70 dark:text-luna-text-dark/70">
        {title}
      </p>
    </div>
  );
};

interface AdminStatsProps {
  stats: AdminStatsType;
  loading?: boolean;
}

export const AdminStats: React.FC<AdminStatsProps> = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="bg-white dark:bg-luna-primary rounded-xl border-2 border-luna-secondary/30 p-4 sm:p-6 animate-pulse"
          >
            <div className="h-6 sm:h-8 bg-luna-secondary/20 rounded mb-3 sm:mb-4" />
            <div className="h-5 sm:h-6 bg-luna-secondary/20 rounded mb-2" />
            <div className="h-3 sm:h-4 bg-luna-secondary/20 rounded w-2/3" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
      <StatCard
        title="Total Users"
        value={stats.totalUsers}
        icon="people"
      />
      <StatCard
        title="Law Topics"
        value={stats.totalTopics}
        icon="topic"
      />
      <StatCard
        title="Active Subscriptions"
        value={stats.activeSubscriptions}
        icon="subscriptions"
      />
      <StatCard
        title="Notifications Sent"
        value={stats.totalNotifications}
        icon="notifications"
      />
      {stats.documentsAnalyzed !== undefined && (
        <StatCard
          title="Documents Analyzed"
          value={stats.documentsAnalyzed}
          icon="description"
        />
      )}
      {stats.revenue !== undefined && (
        <StatCard
          title="Revenue (MTD)"
          value={`€${stats.revenue.toLocaleString()}`}
          icon="payments"
        />
      )}
    </div>
  );
};

